module.exports = __webpack_public_path__ + "img/bauger_01.a0fd0cc1.png";